// extracted by mini-css-extract-plugin
export var active = "_d1-7";
export var blink = "_d1-8";
export var dropDownSelector = "_d1-4";
export var dropDownWrapper = "_d1-3";
export var fakeCursor = "_d1-6";
export var fontSizeButton = "_d1-9";
export var formQuillEditor = "_d1-0";
export var pressed = "_d1-a";
export var qlBlank = "_d1-1";
export var textFormattingToolbar = "_d1-2";
export var textToolbarOption = "_d1-5";